// Soyut SVG illüstrasyonlar — analytics/monitoring dili, oyun teması yok.

// Boş durum: sinyal bekleyen bir radar / nabız hattı
export function EmptySignal({ size = 120 }) {
  return (
    <svg width={size} height={size * 0.72} viewBox="0 0 160 116" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="emptyStroke" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="var(--text-3)" stopOpacity="0.15" />
          <stop offset="50%" stopColor="var(--accent)" stopOpacity="0.55" />
          <stop offset="100%" stopColor="var(--text-3)" stopOpacity="0.15" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="158" height="114" rx="14" stroke="var(--border)" />
      {[29, 58, 87].map((y) => (
        <line key={y} x1="16" y1={y} x2="144" y2={y} stroke="var(--border)" strokeDasharray="2 5" />
      ))}
      <path
        d="M16 58h30l8-18 10 40 9-30 7 14h14l8-10 10 20 7-6h10"
        stroke="url(#emptyStroke)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="80" cy="58" r="4" fill="var(--accent)" opacity="0.5">
        <animate attributeName="opacity" values="0.15;0.6;0.15" dur="2.6s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}

// 404 için soyut kopmuş sinyal
export function BrokenSignal({ size = 160 }) {
  return (
    <svg width={size} height={size * 0.6} viewBox="0 0 200 120" fill="none" aria-hidden="true">
      <path
        d="M10 60h40l10-26 12 40"
        stroke="var(--accent)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M122 74l12-40 10 26h46"
        stroke="var(--text-3)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 6"
      />
      <circle cx="86" cy="74" r="3" fill="var(--accent)" />
      <circle cx="118" cy="60" r="3" fill="var(--text-3)" />
    </svg>
  );
}

// Auth yan panel görseli — katmanlı sinyal halkaları
export function AsideRings({ size = 420 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 420 420" fill="none" aria-hidden="true">
      {[60, 110, 160, 210].map((r, i) => (
        <circle
          key={r}
          cx="210"
          cy="210"
          r={r}
          stroke="var(--accent)"
          strokeOpacity={0.22 - i * 0.04}
          strokeWidth="1"
        />
      ))}
      <path
        d="M40 210h70l24-70 40 150 30-110 20 50h126"
        stroke="var(--accent)"
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="210" cy="210" r="5" fill="var(--accent)" />
    </svg>
  );
}
